import React from "react";
import {AuctionsManager} from "@nextlot/core/webcast";

export default function ViewerEmbeddedHeaderCmp() {
    return (
        <>
            <div className="header__main-container">
                <div className="title-wrapper">
                    <h5 className="title">{AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.auctionName}</h5>
                </div>
            </div>
        </>

    )
}

// import * as React from "react";
// import {AuctionsManager} from "@nextlot/bidding-jsclient-core";
//
// export default class ViewerEmbeddedHeaderCmp extends React.Component {
//
//     constructor(props) {
//         super(props);
//
//         this.auctionConnectData = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData;
//     }
//
//     render() {
//
//         return (
//             <div className="header__main-container">
//                 <div className="title-wrapper">
//                     <h5 className="title">{this.saleConnectData.auctionName}</h5>
//                 </div>
//             </div>
//         )
//     }
//
// }
//
